import { render, staticRenderFns } from "./BuildYourJewelHome.vue?vue&type=template&id=c1b7429e&scoped=true&"
import script from "./BuildYourJewelHome.vue?vue&type=script&lang=js&"
export * from "./BuildYourJewelHome.vue?vue&type=script&lang=js&"
import style0 from "./BuildYourJewelHome.vue?vue&type=style&index=0&id=c1b7429e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b7429e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1b7429e')) {
      api.createRecord('c1b7429e', component.options)
    } else {
      api.reload('c1b7429e', component.options)
    }
    module.hot.accept("./BuildYourJewelHome.vue?vue&type=template&id=c1b7429e&scoped=true&", function () {
      api.rerender('c1b7429e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BuildYourJewelHome.vue"
export default component.exports